<template>
  <smart-church-layout page="Edit Members">
    <v-snackbar
      v-model="snackbar.status"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      >{{ snackbar.msg }}</v-snackbar
    >
    <v-overlay :opacity="0.4" :value="overlay">
      <v-progress-circular indeterminate size="64"> </v-progress-circular>
    </v-overlay>
    <!-- <skeletonLoader v-if="overlay" /> -->

    <v-container fluid  class="my-8">
      <v-btn
        class="bg-transparent ms-7 mt-5"
        small
        :to="{ name: 'AdminMembers' }"
        ><v-icon>mdi-arrow-u-left-top</v-icon></v-btn
      >
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="8">
          <div class="alert alert-danger my-3" v-if="mountedError">
            Data could not be loaded: {{ mountedError }}
            <v-btn
              color="primary white--text"
              :loading="isLoading"
              @click="initMemberInfo"
            >
              Fetch again
            </v-btn>
          </div>

          <v-card class="mt-12 rounded-lg text-capitalize">
            <v-form
              class="my-6 pa-10"
              ref="form"
              @submit.prevent="updateMembers"
            >
              <h2
                class="primary--text d-flex justify-center my-4 font-weight-bold"
              >
                edit Member
              </h2>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="First Name"
                    v-model="member_details.first_name"
                    :error-messages="member_details_errors.first_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Last Name"
                    v-model="member_details.last_name"
                    :error-messages="member_details_errors.last_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    label="Branch"
                    v-model="member_details.branch_id"
                    :items="branches"
                    item-value="id"
                    item-text="name"
                    :error-messages="member_details_errors.branch_id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Email"
                    v-model="member_details.email"
                    :error-messages="member_details_errors.email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Address"
                    v-model="member_details.address"
                    :error-messages="member_details_errors.address"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Phone Number"
                    type="number"
                    v-model="member_details.phone"
                    :error-messages="member_details_errors.phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    type="date"
                    outlined
                    dense
                    label="Date Of Birth"
                    v-model="member_details.date_of_birth"
                    :error-messages="member_details_errors.date_of_birth"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Country"
                    v-model="member_details.country"
                    :error-messages="member_details_errors.country"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="State"
                    v-model="member_details.state"
                    :error-messages="member_details_errors.state"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="City"
                    v-model="member_details.city"
                    :error-messages="member_details_errors.city"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Nationality"
                    v-model="member_details.nationality"
                    :error-messages="member_details_errors.nationality"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Unit in Church"
                    id="unit in church"
                    v-model="member_details.unit_in_church"
                    :error-messages="member_details_errors.unit_in_church"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="status"
                    id="status"
                    label="Status"
                    value="Active"
                    v-model="member_details.status"
                    :error-messages="member_details_errors.status"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div class="img-content">
                    <v-icon x-large>mdi-image-outline</v-icon>
                    <p class="text--secondary">
                      Please upload as a JPG, <br />
                      JPEG or PNG format <br />
                      (not more than 2MB)
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="d-flex align-end">
                  <v-file-input
                    ref="fileInput"
                    :rules="rules"
                    show-size
                    accept="image/png, image/jpeg,"
                    small-chips
                    outlined
                    label="Upload Image"
                    prepend-icon="mdi-camera"
                    dense
                    v-model="photo.logo"
                    class="mx-auto upload-body"
                    :error-messages="photo_errors.logo"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <div class="text-right">
                <v-btn
                  @click="uploadPicture"
                  depressed
                  color="primary white--text"
                  class="mb-2"
                >
                  upload
                </v-btn>
              </div>
              <v-btn
                type="submit"
                depressed
                block
                :loading="isSubmitted"
                :disabled="isSubmitted"
                color="primary white--text"
                >save</v-btn
              >
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </smart-church-layout>
</template>

<script>
import SmartChurchLayout from "../../components/Layouts/SmartChurchLayout.vue"
import { catchAxiosExceptions } from "../../__helpers/handelExceptions"
// import skeletonLoader from "../../components/FormSkeletonLoader.vue"

export default {
  components: { SmartChurchLayout },

  data() {
    return {
      rules: [
        (value) =>
          !value ||
          !value.length ||
          value[0].size < 200000 ||
          "Avatar size should be less than 2 MB!",
      ],
      member_details: [],

      items: ["yes", "no"],
      status: ["Active", "Inactive", "Suspended"],
      overlay: true,

      member_details_errors: {},
      branches: [],

      routeParamSlug: this.$route.params.member_slug,

      isLoading: false,

      isSubmitted: false,

      snackbar: {
        status: false,
        msg: "",
        color: "",
        timeout: 3000,
      },

      mountedError: null,
      photo: {
        logo: "",
      },
      photo_errors: {},
    }
  },

  methods: {
    async initMemberInfo() {
      if (this.routeParamSlug === undefined || this.routeParamSlug.length < 1) {
        this.$router.push({ name: "AdminMembers" })
      } else {
        this.isLoading = true

        try {
          const member_details = await this.$http.get(
            "admin/members/" + this.routeParamSlug
          )
          const user = this.$store.state.userDetail.user;
          this.member_details = member_details.data.data
          this.branches = user.branches;

          this.isLoading = false
          this.overlay = false
        } catch (error) {
          this.mountedError = error.response.data.message
          this.isLoading = false
          this.overlay = false

          catchAxiosExceptions(error)
        }
      }
    },

    updateMembers() {
      this.member_details.error = ""
      this.member_details.response = ""

      this.isSubmitted = true
      // const headers = { "Content-Type": "multipart/form-data" };

      this.$http
        .put("admin/members/" + this.routeParamSlug, this.member_details)
        .then((response) => {
          this.snackbar.status = true
          this.snackbar.msg = response.data.message
          this.snackbar.color = "green"

          this.isSubmitted = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
        })
        .catch((error) => {
          this.snackbar.status = true
          this.snackbar.msg = error.response.data.message
          this.snackbar.color = "red"

          this.member_details_errors = error.response.data.errors
          this.isSubmitted = false

          catchAxiosExceptions(error)
        })
    },
    uploadPicture() {
      const headers = { "Content-Type": "multipart/form-data" }
      this.$http
        .post(`admin/memberImageUpdate/${this.routeParamSlug}`, this.photo, {
          headers,
        })
        .then((response) => {
          this.snackbar.status = true
          this.snackbar.msg = "Picture uploaded successfully"
          this.snackbar.color = "green"
          console.log(response)
        })
        .catch((error) => {
          this.snackbar.status = true
          this.snackbar.msg = error.response.data.message
          this.snackbar.color = "red"
          this.photo_errors = error.response.data.errors
          console.log(error)
        })
    },
  },

  mounted() {
    this.initMemberInfo()
  },
}
</script>

<style scoped>
label {
  color: #c73438;
  font-size: 16px !important;
  margin-bottom: 0.5em !important;
}
.v-icon {
  color: #c73438;
}
.v-text-field--outlined >>> fieldset {
  border-color: rgba(204, 49, 10, 0.986);
}

.itk {
  width: 100%;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.v-text-field::-moz-focus-inner {
  background-color: red !important;
}
.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot:focus {
  background: #eedddd !important;
}
.img-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
